
class TabList {
    defaultOptions() {
        return {
            '$mainContainer': $('body'),
            '$container': null,

            'fieldName': 'field',
            'linkSelector': '.btn-tab',
            'itemSelector': '.item',
            'countSelector': '.count',
            'activeClass': 'active',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(!this.$container){
            window.notify("$container is missing in ui/TabList ","error");
        }
        this.$mainContainer = this.settings.$mainContainer;

        this.linkSelector = this.settings.linkSelector;
        this.itemSelector = this.settings.itemSelector;
        this.countSelector = this.settings.countSelector;
        this.activeClass = this.settings.activeClass;
        this.fieldName = this.settings.fieldName;

        this.initialize();
    }


    initialize(){
        var self = this;

        console.log("Tab list",this);


        this.fillCount();

        $(this.linkSelector,this.$container).on('click',function(event){
            event.stopPropagation();
            event.preventDefault();

            let $link = $(this);

            self.onClickLink($link)
        })
    }

    fillCount(){
        var self = this;

        $(this.linkSelector,this.$container).each(function(){

            let $link = $(this);
            let value = $link.data(self.fieldName);

            let selector = self.itemSelector+'[data-'+self.fieldName+'="'+value+'"]';
            if(value == '' || value == 'all'){
                selector = self.itemSelector;
            }


            let count = $(selector,self.$mainContainer).length;

            let $count = $(self.countSelector,$link);

            if($count.length > 0){
                $count.html('').append(' ('+count+')');
            }
            if(count <= 0){
                $link.prop('disabled',true);
            }

        })
    }

    onClickLink($link){
        $(this.linkSelector,this.$container).removeClass(this.activeClass);
        $link.addClass(this.activeClass);
        
        let value = $link.data(this.fieldName);
        this.filter(value);
    }

    filter(value){
        var self = this;
        if(value == 'all' || value == ''){
            $(this.itemSelector,this.$mainContainer).show();    
        }else{
            $(this.itemSelector,this.$mainContainer).hide();
            $(this.itemSelector,this.$mainContainer).each(function(){
                let $item = $(this);

                if($item.data(self.fieldName) == value){
                    $item.show();
                }
            })

        }

    }

}

module.exports = TabList;